import {AsyncInlineError} from '@s-ui/decorators'

import MotorFetcherFactory from '../../fetcher/Fetchers/factory.js'
import {DeleteNewsBookmarksError} from '../Errors/DeleteNewsBookmarksError.js'
import {GetSavedNewsIdsError} from '../Errors/GetSavedNewsIdsError.js'
import {SaveNewsBookmarksError} from '../Errors/SaveNewsBookmarksError.js'
import {NewsBookmarksRepository} from './NewsBookmarksRepository.js'

export class HttpNewsBookmarksRepository extends NewsBookmarksRepository {
  #config
  #fetcher

  static create({config}) {
    return new HttpNewsBookmarksRepository({
      config,
      fetcher: MotorFetcherFactory.httpAuthenticationFetcher({config})
    })
  }

  constructor({config, fetcher}) {
    super()
    this.#config = config
    this.#fetcher = fetcher
  }

  #getBaseUrl({userId}) {
    return `${this.#config.get('API_URL')}/users/${userId}/preferences/saved-for-later/articles`
  }

  @AsyncInlineError()
  async save({userId, articleId}) {
    try {
      await this.#fetcher.post(this.#getBaseUrl({userId}), {articleId})
    } catch {
      throw SaveNewsBookmarksError.create('[HttpNewsBookmarksRepository#save] Error saving article bookmark')
    }
  }

  @AsyncInlineError()
  async delete({userId, articleId}) {
    try {
      await this.#fetcher.delete(`${this.#getBaseUrl({userId})}/${articleId}`)
    } catch {
      throw DeleteNewsBookmarksError.create('[HttpNewsBookmarksRepository#delete] Error deleting article bookmark')
    }
  }

  @AsyncInlineError()
  async getSavedIds({userId, page = 0, size = 200}) {
    try {
      const response = await this.#fetcher.get(`${this.#getBaseUrl({userId})}?page=${page}&size=${size}`)
      return response.data.map(({articleId}) => articleId)
    } catch {
      throw GetSavedNewsIdsError.create('[HttpNewsBookmarksRepository#getSavedIds] Error retrieving saved article IDs')
    }
  }
}
